import React from 'react'

import { InfoBox, MarkerF } from '@react-google-maps/api'

import { InfoWindow } from './InfoWindow'

import { useGoogleMap } from '../../../hooks/useGoogleMap'

import { Parking } from '../../../@types/entities/entities.types'

type MarkerProps = {
  data: Parking
}

export function Marker({ data }: MarkerProps) {
  const { activeMarker, selectMarker } = useGoogleMap()

  const url = React.useMemo(() => {
    if (activeMarker?.id === data.id) {
      if (data.parking_configurations.allow_scheduling) {
        if (data.parking_configurations.premium) {
          return 'https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/marker-scheduling-vip-selected.svg'
        }

        return 'https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/marker-scheduling-selected.svg'
      }

      if (data.parking_configurations.premium) {
        return 'https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/marker-not-scheduling-vip-selected.svg'
      }

      return 'https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/marker-not-scheduling-selected.svg'
    }

    if (data.parking_configurations.allow_scheduling) {
      if (data.parking_configurations.premium) {
        return 'https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/marker-scheduling-vip.svg'
      }

      return 'https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/marker-scheduling.svg'
    }

    if (data.parking_configurations.premium) {
      return 'https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/marker-not-scheduling-vip.svg'
    }

    return 'https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/marker-not-scheduling.svg'
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMarker])

  return (
    <MarkerF
      key={data.id}
      icon={{
        url: url,
      }}
      position={{
        lat: data.parking_address.latitude,
        lng: data.parking_address.longitude,
      }}
      options={{
        optimized: true,
      }}
      onClick={() =>
        selectMarker({
          id: data.id,
          position: {
            lat: data.parking_address.latitude,
            lng: data.parking_address.longitude,
          },
        })
      }
    >
      {activeMarker?.id === data.id && (
        <InfoBox
          options={{
            closeBoxURL: '',
            enableEventPropagation: true,
            pixelOffset: new google.maps.Size(-160, -160),
          }}
          position={
            new google.maps.LatLng({
              lat: data.parking_address.latitude,
              lng: data.parking_address.longitude,
            })
          }
        >
          <InfoWindow data={data} />
        </InfoBox>
      )}
    </MarkerF>
  )
}
